import React, {Component, PropTypes} from 'react';
import {Icon, Badge} from 'antd';
import {style} from '../style';
import {Map} from 'immutable';
import * as colors from 'material-ui/styles/colors';
import FontIcon from 'material-ui/FontIcon';
import {parseUsername} from '../../util';

export default class Header extends Component {

    static propTypes = {
        usersMap: PropTypes.object,
        issues: PropTypes.array,
        pushIssues: PropTypes.string,
        account: PropTypes.object,
    };

    static defaultProps = {
        usersMap: Map,
        issuesMap: Map,
        pushIssues: '',
        account: {},
    };

    getAssignedColor(assignedID) {
        if (assignedID && this.props.event.statusID !== 1 && this.props.event.statusID !== 8) {
            let user = this.props.usersMap.get(assignedID.toString());

            if (user) {
                let color = user.get('color');
                if (color) {
                    return color;
                }
            }
        }

        if (this.props.event.engineerID && this.props.event.engineerID > 0 && this.props.event.statusID === 8) {
            let engineerID = this.props.event.engineerID;
            let user = this.props.usersMap.get(engineerID.toString());

            if (this.props.event.engineerMore && this.props.event.engineerMore.length > 0) {
                let arrEngineerMore = this.props.event.engineerMore.split(',');

                if (arrEngineerMore && arrEngineerMore.length > 0) {
                    arrEngineerMore.map((engineerID) => {
                        if (parseInt(engineerID) === this.props.account.user.id) {
                            user = this.props.usersMap.get(engineerID);
                        }
                    })
                }
            }

            if (user) {
                let color = user.get('color');

                if (color) {
                    return color;
                }
            }
        }

        return colors.grey500;
    }

    getIconByStatus(statusID) {
        switch (statusID) {
            case 3:
                return 'done';
            case 2:
                return 'play_arrow';
            case 4:
                return 'perm_phone_msg';
            case 6:
                return 'error_outline';
            case 5:
                return 'clear';
            case 7:
                return 'build';
            case 8:
                return 'loop';
            default:
                return '';
        }
    }

    getHeaderName() {
        if (this.props.event.statusID === 8) {
            if (this.props.event.engineerID) {
                let engineerID = this.props.event.engineerID;
                let user = this.props.usersMap.get(engineerID.toString());

                if (user) {
                    if (this.props.event.engineerMore) {
                        let arrEngineerMore = this.props.event.engineerMore.split(',');

                        if (arrEngineerMore && arrEngineerMore.length > 0) {
                            let userMore = this.props.usersMap.get(arrEngineerMore[0]);

                            if (userMore) {
                                if (arrEngineerMore.length === 1) {
                                    return `${parseUsername(user.get('firstname'), user.get('lastname'))} - ${parseUsername(userMore.get('firstname'), userMore.get('lastname'))}`
                                }

                                return `${parseUsername(user.get('firstname'), user.get('lastname'))} - ${parseUsername(userMore.get('firstname'), userMore.get('lastname'))} ...`
                            }
                        }
                    }

                    return parseUsername(user.get('firstname'), user.get('lastname'));
                }
            }
        } else {
            if (this.props.event.assignedName) {
                return `${this.props.event.assignedName} ${this.props.event.assignedMore ? this.props.event.assignedMore.split(',').map((userID) => {
                    const assignedUser = this.props.usersMap.get(userID.toString());
                    return assignedUser ? ' - ' + assignedUser.get('firstname') : '';
                }) : ''}`;
            }
        }

        return <Icon style={style.issueIconUser} type="user"/>;
    }

    render() {
        return (
            <div style={{
                position: 'absolute',
                top: '0px',
                fontWeight: 600,
                backgroundColor: this.getAssignedColor(this.props.event.assignedToID),
                height: '17px',
                width: '100%'
            }}>

                {
                    this.props.event.statusID === 1 ?
                        <i
                            style={{widows: '25px', position: 'absolute', left: '1px', top: '2px', fontSize: '9px'}}>
                            New
                        </i>
                        :
                        <FontIcon
                            className="material-icons"
                            style={{
                                padding: '2px',
                                left: '0px',
                                position: 'absolute',
                                float: 'left',
                                color: '#fff',
                                fontSize: '15px',
                                fontWeight: 600
                            }}
                        >
                            {this.getIconByStatus(this.props.event.statusID)}
                        </FontIcon>
                }

                {this.props.event.statusID === 2 ? <Badge status="processing"/> : null}
                <span style={{top: '2px', position: 'relative', padding: '0px 15px', lineHeight: '1.2em'}}>
                    {
                        this.getHeaderName()
                    }
                </span>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/schedule/issues/header/header.js